import { type SxProps, type Theme } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import type { ReactNode } from "react";

interface ChatSeparatorProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export function ChatSeparator(props: ChatSeparatorProps) {
  const { children, sx } = props;

  return (
    <Text semibold variant="caption" color="text.tertiary" textAlign="center" sx={sx}>
      {children}
    </Text>
  );
}
